import type { ReactElement } from 'react';
import { formatLongDate, APP_DEFAULT_TZ, currentLang } from '@utils/dateUtils';
import { Tooltip, TooltipContent } from '../Tooltip/Tooltip';

interface IMilestoneTooltipProps {
  name: string;
  dateIso: string;
  children: ReactElement; // the trigger element (the diamond)
}

/** Milestone popup — name over a muted JST-formatted date. A thin preset over
 *  `ui/Tooltip`'s marker variant; the styling itself lives there. */
export function MilestoneTooltip({ name, dateIso, children }: IMilestoneTooltipProps) {
  const lang = currentLang();
  return (
    <Tooltip
      variant="marker"
      sideOffset={8}
      content={<TooltipContent title={name} lines={[formatLongDate(dateIso, lang, APP_DEFAULT_TZ)]} />}
    >
      {children}
    </Tooltip>
  );
}
